import { captureException } from '@sentry/browser';

const mathEquationSelector = `span.quill-math`;

/**
 * Check if a given html string has latex equations in it
 * @param htmlString
 */
export function getMathEquations(htmlString: string) {
  if (htmlString == null) {
    return [];
  }

  try {
    const domParser = new DOMParser();
    const doc = domParser.parseFromString(htmlString, 'text/html');

    if (!doc) return [];

    const elements = doc.querySelectorAll(mathEquationSelector);
    const formulas: Array<string> = [];

    for (const element of elements) {
      const latex = element.getAttribute('data-latex');

      if (latex != null) {
        formulas.push(latex);
      }
    }

    return formulas;
  } catch (e) {
    captureException(e);
    return [];
  }
}
